<template>
    <v-dialog v-if="isLeserserviceOrHigher" v-model="showDialog" max-width="800" class="flex-none" persistent>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" v-bind="$attrs" class="drei_60-btn mb-2" block>Newsletter-Abonnements</v-btn>
        </template>

        <v-card>
            <v-card-title>Newsletter-Abonnements</v-card-title>

            <div v-if="loading" class="my-12 text-center">
                <v-progress-circular indeterminate :size="40" color="primary"></v-progress-circular>
            </div>
           
            <v-card-text v-else-if="newsletters">
                <ul class="filters">
                    <li v-for="item in portals" :key="item" :class="(portal == item ? 'active' : '')" @click="portal = item">
                        {{ item }} ({{ newsletters.filter(newsletter => { return newsletter.subscribed && newsletter.portal == item }).length }})
                    </li>
                </ul>

                <v-simple-table class="mt-3">
                    <thead class="v-data-table-header">
                        <tr>
                            <th>Titel</th>
                            <th>ID in Evalanche</th>
                            <th>Portal</th>
                            <th>Zustimmung</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in newsletters" v-show="item.portal == portal" :key="index" @click="item.subscribed = !item.subscribed">
                            <td>{{ item.name }}</td>
                            <td>{{ item.key }}</td>
                            <td>{{ item.portal.toUpperCase() }}</td>
                            <td>{{ item.subscribed_before ? (item.doi ? 'Ja' : 'Nein') : '' }}</td>
                            <td><input type="checkbox" v-model="item.subscribed" :disabled="busy"></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>

            <v-card-text v-else>
                Es konnten keine Newsletter gefunden werden.
            </v-card-text>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" outlined @click="abort">Abbrechen</v-btn>
                <v-btn color="success" outlined @click="save" :loading="busy" :disabled="loading">Speichern</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import Http from '@/api/http';

    export default {
        name: 'newsletters',
        props: ['ssoId', 'email'],
        components: {},
        
        data() {
            return {
                showDialog: false,
                loading: true,
                busy: false,
                newsletters: [],
                portals: [],
                portal: '',
            };
        },

        computed: {
            ...mapGetters(['isLeserserviceOrHigher']),
        },

        methods: {
            ...mapMutations('snackbar', {
                snackError: 'error', snackSuccess: 'success', snackInfo: 'info',
            }),

            abort() {
                this.$emit('close');
                this.showDialog = false;
                this.newsletters = [];
            },

            save() {
                const keys = {};

                // check which portals are selected for update
                this.newsletters.map(item => {
                    if(item.subscribed != item.subscribed_before) {
                        keys[item.portal] = [];
                    }
                });

                // fill portal array with keys for subscribed newsletters
                for(let portal in keys) {
                    this.newsletters.map(item => {
                        if(item.portal == portal && item.subscribed) {
                            keys[item.portal].push(item.key);
                        }
                    });
                }

                // request
                this.busy = true;

                Http.post('/customer/newsletters/update', {
                    email: this.email,
                    keys,
                }).then((response) => {
                    this.snackSuccess('Die Newsletter-Abonnements wurden erfolgreich aktualisiert.');
                }).catch(error => {
                    this.snackError('Es ist ein Fehler beim Speichern der Newsletter-Abonnements aufgetreten.');
                }).finally(() => {
                    this.busy = false;
                    this.showDialog = false;
                    this.$emit('close');
                });
            },
        },

        watch: {
            showDialog(status) {
                if(status) {
                    this.loading = true;
                    this.newsletters = [];

                    Http.post('/customer/newsletters/list', {
                        email: this.email,
                    }).then((response) => {
                        this.loading = false;

                        if(response.data && response.data.data) {
                            response.data.data.map(item => {
                                item.subscribed_before = item.subscribed;
                                this.newsletters.push(item);
                                this.portals.push(item.portal);
                            });

                            this.portals = [...new Set(this.portals)];
                            this.portal = this.portals[0];
                        }
                    });
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    ul.filters {
        display: flex;
        gap: 0.75em;
        margin-top: 1.5em;
        padding: 0;
        list-style: none;

        & li {
            padding: 0 16px;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            text-transform: uppercase;
            color: #757575;

            &.active {
                border-color: #c1c1c1;
                color: #c7c7c7;
            }
        }
    }

    tbody tr {
        cursor: pointer;
    }
</style>